exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-41212324] .v-datatable.v-table>tbody{max-height:none!important;min-height:0!important}", ""]);

// exports
